import { render } from "./ProfessionPage.vue?vue&type=template&id=af362aa2"
import script from "./ProfessionPage.vue?vue&type=script&lang=js"
export * from "./ProfessionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__